{
  "home": {
    "heroStop": "DETENGAN EL HUMAN SAFARI",
    "heroSave": "SALVEMOS JERSÓN",
    "heroTitle1": "Los seres humanos",
    "heroTitle2": "No son objetivos",
    "heroDate": "13-14 de diciembre",
    "worldwideRally": "Acción global",
    "heroHashtags": "#LosSeresHumanosNoSonObjetivos #StopHumanSafari #SaveKherson",
    "infoText": "Desde el verano de 2024, el ejército ruso utiliza pequeños drones para cazar, matar y aterrorizar a los civiles en las calles de Jersón y otras ciudades en primera línea en Ucrania. <bold>El safari humano debe detenerse. TÚ puedes ayudar.</bold> Únete a miles de personas en todo el mundo para exigir que este crimen de guerra termine.",
    "seeGallery": "Ver carteles de todo el mundo",
    "comingSoon": "Ubicaciones próximamente",
    "december": "de diciembre",
    "dec": "dic.",
    "october": "de octubre",
    "oct": "oct.",
    "september": "de septiembre",
    "sep": "sept.",
    "schedule9": "9",
    "schedule10": "10",
    "schedule11": "11",
    "schedule12": "12",
    "schedule13": "13",
    "schedule14": "14",
    "schedule16": "16",
    "schedule18": "18",
    "schedule20": "20",
    "schedule1": "1",
    "schedule2": "2",
    "schedule3": "3",
    "schedule4": "4",
    "schedule5": "5",
    "schedule25": "25",
    "schedule26": "26",
    "schedule27": "27",
    "schedule28": "28",
    "schedule29": "29",
    "schedule30": "30",
    "schedule31": "31",
    "scheduleTBC": "Fecha por confirmar...",
    "recommendationsTitle": "Recomendaciones de la Comisión de la ONU",
    "recommendationsRussia": "La Comisión recomienda que la Federación Rusa:",
    "rusRec1": "(a) Ponga fin de inmediato a los ataques con drones dirigidos a civiles y objetos civiles",
    "rusRec2": "(b) Detenga inmediatamente todos los actos que propaguen terror entre la población civil",
    "rusRec3": "(c) Asegure que todos los responsables de ataques con drones contra civiles sean llevados ante la justicia",
    "recommendationsUNStates": "La Comisión recomienda que otros Estados y organizaciones regionales e internacionales:",
    "statesRec1": "(a) Contribuyan tanto financieramente como con asesoramiento técnico al Gobierno de Ucrania y a las organizaciones de la sociedad civil, para proporcionar apoyo integral a las víctimas y sus familias;",
    "statesRec2": "(b) Para los Estados terceros cuyo territorio sea el destino de personas deportadas desde los territorios ocupados, realizar los esfuerzos necesarios junto con los servicios consulares ucranianos para apoyar a estas personas.",
    "reference": "Referencia",
    "linkUN": "Comisión de la ONU: El \"safari humano\" de Rusia en Ucrania es un crimen contra la humanidad",
    "linkGuidelines": "Directrices de la ONU",
    "linkWiki": "Wikipedia"
  },
  "witnesses": {
    "title": "¡Estamos recopilando testimonios de testigos!",
    "email": "Si eres de Jersón, Nikopol, Zaporizhia, Sumy o de las áreas de primera línea del Donbás y si has presenciado un “safari humano”, envíanos tus historias a 📧 <mail>khersonhumansafari@gmail.com</mail>, asunto: “safari humano”.",
    "type": "Si presenciaste la muerte de un amigo o vecino en un ataque con drones y deseas compartir tu relato, indica “testigo ocular”; si fuiste atacado personalmente, indica “superviviente”.",
    "requirements": "<b>Lo que necesitamos:</b> ciudad/ubicación, fecha del ataque, breve relato (3–6 frases; factual, en primera persona).",
    "honesty": "Sé honesto, conciso y evita incluir posiciones militares sensibles — puedes permanecer en el anonimato.",
    "media": "<b>¿Fotos/videos?</b> Escribe “Fotos/videos disponibles”. No adjuntes archivos — nos pondremos en contacto si se necesitan materiales visuales.",
    "consent": "<b>Consentimiento para publicación:</b> “Acepto que esta historia sea publicada públicamente en el sitio HumanSafari.org.”"
  },
  "resources": {
    "title": "Recursos clave",
    "linkLibraryTitle": "Biblioteca de enlaces",
    "linkLibraryDesc": "200 artículos, informes, entrevistas, testimonios directos y cobertura mediática",
    "humanSafariMapTitle": "Mapa del Human Safari de Tochnyi",
    "humanSafariMapDesc": "Un mapa interactivo de los ataques del Human Safari en Jersón, elaborado a partir de informes de fuentes abiertas de las autoridades locales y de vídeos de los ataques geolocalizados por el equipo de Tochnyi.",
    "truthHoundsTitle": "Informe Truth Hounds",
    "truthHoundsDesc": "Killzone: Cómo los drones rusos devastan la margen derecha del río Dniéper",
    "hrwTitle": "Informe de Human Rights Watch sobre ataques con drones en Jersón",
    "hrwDesc": "Informe HRW",
    "unReportsTitle": "Informes del Consejo de Derechos Humanos de la ONU",
    "report1": "Informe ONU #1",
    "report3": "Informe ONU #3",
    "guidelines": "Directrices de la ONU",
    "wikipediaTitle": "Wikipedia",
    "english": "Inglés",
    "french": "Francés",
    "documentaryTitle": "Documental",
    "documentaryDesc": "www.khersonhumansafari.com"
  },
  "navbar": {
    "main": "13-14 dic",
    "eyewitnesses": "testimonios",
    "rallies": "fotos",
    "help": "Jersón desocupada",
    "leftBank": "Jersón ocupada",
    "action": "dic '25",
    "oleshky": "acción global - Oleshky",
    "menu": "Menú"
  },
  "leftBank": {
    "pageTitle": "Asedio con drones",
    "para1": "Una grave emergencia humanitaria afecta a 6000 civiles atrapados bajo un asedio con drones en las localidades ocupadas de Oleshky, Hola Prystan, Stara Zburivka y Nova Zburivka - región ocupada de Jersón. En Oleshky, entre 1200 y 2000. La autoridad ocupante está obligada a asistirlos - en cambio, las fuerzas rusas los utilizan como escudos humanos para esconderse tras esta población mientras llevan a cabo ataques de safari humano en la margen opuesta. Las autoridades ucranianas y las organizaciones humanitarias denuncian una obstrucción sistemática de la evacuación y del acceso humanitario.",
    "para2": "Los civiles carecen de alimentos, agua, atención médica, medicamentos, electricidad, gas y comunicaciones. Las carreteras están fuertemente minadas y la actividad de drones restringe el movimiento. Ningún vehículo ha podido entrar ni salir desde el 26 de mayo. Las reservas de combustible y alimentos están casi agotadas.",
    "meidasTitle": "Meidas Touch / Valor Media Network",
    "meidasVideo": "Vídeo: «Kherson and Oleshky: Witnessing Genocide» (12 min)",
    "meidasArticle": "Artículo: «The Kherson Region: How Russia Uses Civilians as a Tool of War» (5 min de lectura)",
    "kyivPostTitle": "Kyiv Post",
    "kyivPostArticle": "Artículo: «Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate» (7 min de lectura)",
    "tellPost": "y cuéntaselo a los demás",
    "callToHelp": "TÚ puedes ayudar. Así es cómo",
    "donateIntro": "Estas son iniciativas que ofrecen ayuda específica y de gran impacto directamente a las personas que han huido de Oleshky o, donde es posible, siguen atrapadas allí.",
    "signTitle": "Firma",
    "signSub": "peticiones",
    "petitionBy": "de {{name}}",
    "petitions": {
      "euParliament": "Parlamento Europeo – Petición n.º 1439/2026 sobre la creación de un corredor humanitario de evacuación para los civiles atrapados bajo asedio en Oleshky (Ucrania), ocupada por Rusia",
      "ukParliament": "Parlamento del Reino Unido – Impulsar un corredor de ayuda humanitaria liderado por el Reino Unido hacia Oleshky, en Ucrania"
    },
    "publicActionLead": "Pon el foco sobre el asedio con drones allí donde estés.",
    "organiseAction": "Organiza una acción.",
    "policyBody": "Las autoridades ucranianas mantienen consultas con el Comité Internacional de la Cruz Roja sobre el establecimiento de un corredor humanitario de evacuación desde las localidades ocupadas de la región de Jersón y la garantía de acceso humanitario para alimentos, agua, medicinas, combustible y asistencia médica. A principios de junio, no existe ningún corredor de evacuación operativo ni un mecanismo sostenido de acceso humanitario.",
    "documentaryTitle": "Oleshky, documental corto",
    "downloadTitle": "Descargar",
    "downloadSub": "gráficos"
  },
  "footer": {
    "addCityText": "Para agregar tu ciudad, envía un correo electrónico a: ",
    "organiseText": "Añade tu manifestación - ponte en contacto:",
    "contact": "Contacto:"
  },
  "byCountry": "ver por país",
  "byDate": "ver por fecha",
  "countries": {
    "australia": "Australia",
    "austria": "Austria",
    "bulgaria": "Bulgaria",
    "canada": "Canadá",
    "czechia": "Chequia",
    "denmark": "Dinamarca",
    "estonia": "Estonia",
    "finland": "Finlandia",
    "france": "Francia",
    "georgia": "Georgia",
    "germany": "Alemania",
    "hungary": "Hungría",
    "italy": "Italia",
    "japan": "Japón",
    "mexico": "México",
    "netherlands": "Países Bajos",
    "norway": "Noruega",
    "poland": "Polonia",
    "romania": "Rumanía",
    "spain": "España",
    "sweden": "Suecia",
    "southAfrica": "Sudáfrica",
    "ukraine": "Ucrania",
    "unitedKingdom": "Reino Unido",
    "usa": "EE. UU.",
    "ireland": "Irlanda",
    "belgium": "Bélgica"
  },
  "cities": {
    "alicante": {
      "city": "Alicante",
      "country": "España",
      "time": "Alicante - España, 16:00 - 17:00",
      "location": "Auditorio la Concha, Explanada de España",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule13"
    },
    "barcelona": {
      "city": "Barcelona",
      "country": "España",
      "time": "Barcelona - España, 12:00 - 14:00",
      "location": "Placa de Sant Jaume",
      "cleanTime": "12:00 - 14:00",
      "day": "schedule14"
    },
    "berkeley": {
      "city": "Berkeley",
      "country": "EE. UU.",
      "time": "Berkeley - EE. UU., 12:00 - 13:00",
      "location": "4th St.",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "berlin": {
      "city": "Berlín",
      "country": "Alemania",
      "time": "Berlín - Alemania, 12:00",
      "location": "Tempelhofer Feld, entrada Leinstr./esquina de Oderstr.",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "bettendorf": {
      "city": "Bettendorf",
      "country": "EE. UU.",
      "time": "Bettendorf - EE. UU., 17:30 - Proyección",
      "location": "Bettendorf Public Library",
      "cleanTime": "17:30 - Proyección",
      "day": "schedule11"
    },
    "birmingham": {
      "city": "Birmingham",
      "country": "Reino Unido",
      "time": "Birmingham - Reino Unido, 14:00 - 15:30",
      "location": "Baskerville House, Cambridge St.",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "bonn": {
      "city": "Bonn",
      "country": "Alemania",
      "time": "Bonn - Alemania, 14:00 - 16:00",
      "location": "Poststraße, frente a la estación central",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "bremen": {
      "city": "Bremen",
      "country": "Alemania",
      "time": "Bremen - Alemania, 15:00 - 18:00",
      "location": "Bahnhofsvorplatz",
      "cleanTime": "15:00 - 18:00",
      "day": "schedule14"
    },
    "budapest": {
      "city": "Budapest",
      "country": "Hungría",
      "time": "Budapest - Hungría, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "chicago": {
      "city": "Chicago",
      "country": "EE. UU.",
      "time": "Chicago - EE. UU., 13:00 - 15:00",
      "location": "410 N. Michigan ave. (Wrigley Building)",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "constanta": {
      "city": "Constanța",
      "country": "Rumanía",
      "time": "Constanța - Rumanía, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "copenhagen": {
      "city": "Copenhague",
      "country": "Dinamarca",
      "time": "Copenhague - Dinamarca, 14:00",
      "location": "Axeltorv",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "dallas": {
      "city": "Dallas",
      "country": "EE. UU.",
      "time": "Dallas - EE. UU., 12:00 - 13:00",
      "location": "Dallas City Hall Plaza",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "denver": {
      "city": "Denver",
      "country": "EE. UU.",
      "time": "Denver - EE. UU., 12:00",
      "location": "Colorado Capitol Building, escaleras oeste",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "edinburgh": {
      "city": "Edimburgo",
      "country": "Reino Unido",
      "time": "Edimburgo - Reino Unido, 13:00 - 15:00",
      "location": "Duke of Wellington Monument",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule13"
    },
    "fortWorth": {
      "city": "Fort Worth",
      "country": "EE. UU.",
      "time": "Fort Worth - EE. UU., 14:00 - 15:00",
      "location": "Tarrant County Courthouse",
      "cleanTime": "14:00 - 15:00",
      "day": "schedule14"
    },
    "hamburg": {
      "city": "Hamburgo",
      "country": "Alemania",
      "time": "Hamburgo - Alemania, 14:00 - 16:00",
      "location": "Mönckebergbrunnen (Mönckebergstraße)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule20"
    },
    "houghton": {
      "city": "Houghton, Michigan",
      "country": "EE. UU.",
      "time": "Houghton, Michigan - EE. UU., 15:00",
      "location": "Portage Lake Lift Bridge",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "helsinki": {
      "city": "Helsinki",
      "country": "Finlandia",
      "time": "Helsinki - Finlandia, 17:00 - 18:00",
      "location": "Narinkkatori",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule16"
    },
    "izumo14": {
      "city": "Izumo",
      "country": "Japón",
      "time": "Izumo - Japón, 13:00",
      "location": "Santuario Izumo Taisha, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "13:00",
      "day": "schedule14"
    },
    "izumo20": {
      "city": "Izumo",
      "country": "Japón",
      "time": "Izumo - Japón",
      "location": "Santuario Izumo Taisha, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "",
      "day": "schedule20"
    },
    "kamloops": {
      "city": "Kamloops",
      "country": "Canadá",
      "time": "Kamloops - Canadá, 15:00 - 16:00",
      "location": "Ayuntamiento",
      "cleanTime": "15:00 - 16:00",
      "day": "schedule13"
    },
    "kyiv": {
      "city": "Kyiv",
      "country": "Ucrania",
      "time": "Kyiv - Ucrania, 17:00 - 18:00",
      "location": "Maidan Nezalezhnosti",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule14"
    },
    "leipzig": {
      "city": "Leipzig",
      "country": "Alemania",
      "time": "Leipzig - Alemania, 12:00 - 13:00",
      "location": "Willy Brandt Platz",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "london": {
      "city": "Londres",
      "country": "Reino Unido",
      "time": "Londres - Reino Unido, 18:30 - Proyección",
      "location": "Ukrainian House, 154 Holland Park Avenue",
      "cleanTime": "18:30 - Proyección",
      "day": "schedule12"
    },
    "losAngeles": {
      "city": "Los Ángeles",
      "country": "EE. UU.",
      "time": "Los Ángeles - EE. UU., 15:30",
      "location": "4051 Melrose Ave",
      "cleanTime": "15:30",
      "day": "schedule14"
    },
    "malaga": {
      "city": "Málaga",
      "country": "España",
      "time": "Málaga - España, 18:00 - Proyección",
      "location": "Maydan - Centro Histórico Cultural Ucraniano",
      "cleanTime": "18:00 - Proyección",
      "day": "schedule13"
    },
    "manchester": {
      "city": "Manchester",
      "country": "Reino Unido",
      "time": "Manchester - Reino Unido, 14:00 - 15:30",
      "location": "St Peter's Square Emmeline Pankhurst Memorial",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "mexicoCity": {
      "city": "Ciudad de México",
      "country": "México",
      "time": "Ciudad de México - México, 11:00",
      "location": "Alameda Central. Fuente \"Américas\" (entre Hemiciclo Juárez y Kiosco)",
      "cleanTime": "11:00",
      "day": "schedule14"
    },
    "milan": {
      "city": "Milán",
      "country": "Italia",
      "time": "Milán - Italia, 15:00",
      "location": "Catedral de Milán",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "munich": {
      "city": "Múnich",
      "country": "Alemania",
      "time": "Múnich - Alemania, 17:00 - 19:00",
      "location": "Odeonsplatz",
      "cleanTime": "17:00 - 19:00",
      "day": "schedule14"
    },
    "newYork13": {
      "city": "Nueva York",
      "country": "EE. UU.",
      "time": "Nueva York - EE. UU., 16:00",
      "location": "Times Square",
      "cleanTime": "16:00",
      "day": "schedule13"
    },
    "newYork14": {
      "city": "Nueva York",
      "country": "EE. UU.",
      "time": "Nueva York - EE. UU., 13:00 - 14:00",
      "location": "Times Square",
      "cleanTime": "13:00 - 14:00",
      "day": "schedule14"
    },
    "nienburg": {
      "city": "Nienburg (Weser)",
      "country": "Alemania",
      "time": "Nienburg (Weser) - Alemania, 17:00",
      "location": "Stettiner Str.2A",
      "cleanTime": "17:00",
      "day": "schedule13"
    },
    "oslo": {
      "city": "Oslo",
      "country": "Noruega",
      "time": "Oslo - Noruega, 12:00 - 13:00",
      "location": "Eidsvoll Plass, Stortinget",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule14"
    },
    "ostersund": {
      "city": "Östersund",
      "country": "Suecia",
      "time": "Östersund - Suecia, 11:00 - 14:00",
      "location": "Stortorget (Plaza principal)",
      "cleanTime": "11:00 - 14:00",
      "day": "schedule13"
    },
    "ottawa12": {
      "city": "Ottawa",
      "country": "Canadá",
      "time": "Ottawa - Canadá, 12:30 - 13:30",
      "location": "Embajada de rusia",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule12"
    },
    "ottawa13": {
      "city": "Ottawa",
      "country": "Canadá",
      "time": "Ottawa - Canadá, 12:00",
      "location": "Embajada de EE. UU.",
      "cleanTime": "12:00",
      "day": "schedule13"
    },
    "paris": {
      "city": "París",
      "country": "Francia",
      "time": "París - Francia, 15:30",
      "location": "Square Taras Chevchenko -> Fontaine Saint-Michel (marcha)",
      "cleanTime": "15:30",
      "day": "schedule13"
    },
    "plovdiv": {
      "city": "Plovdiv",
      "country": "Bulgaria",
      "time": "Plovdiv - Bulgaria, 16:00 - 17:00",
      "location": "junto a la Casa Levski",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule14"
    },
    "prague": {
      "city": "Praga",
      "country": "Chequia",
      "time": "Praga - Chequia, 14:00",
      "location": "Palackého Square",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "rosendal": {
      "city": "Rosendal",
      "country": "Sudáfrica",
      "time": "Rosendal - Sudáfrica, 11:00",
      "location": "Oficinas del South African Police Service",
      "cleanTime": "11:00",
      "day": "schedule13"
    },
    "sanAndres": {
      "city": "San Andrés, Tenerife",
      "country": "España",
      "time": "San Andrés, Tenerife - España, 13:00",
      "location": "--",
      "cleanTime": "13:00",
      "day": "schedule13"
    },
    "sanDiego": {
      "city": "San Diego",
      "country": "EE. UU.",
      "time": "San Diego - EE. UU., 14:00 - 16:00",
      "location": "El Cid Statue, Balboa Park",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "sanFrancisco": {
      "city": "San Francisco",
      "country": "EE. UU.",
      "time": "San Francisco - EE. UU., 14:00",
      "location": "Ferry Plaza, Embarcadero",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "schwerin": {
      "city": "Schwerin",
      "country": "Alemania",
      "time": "Schwerin - Alemania, 19:00 - Proyección",
      "location": "Internationales Haus, Ziegenmarkt 4",
      "cleanTime": "19:00 - Proyección",
      "day": "schedule13"
    },
    "seattle": {
      "city": "Seattle",
      "country": "EE. UU.",
      "time": "Seattle - EE. UU., 12:30 - 15:30",
      "location": "1005 E Union St.",
      "cleanTime": "12:30 - 15:30",
      "day": "schedule13"
    },
    "svetiVlas": {
      "city": "Sveti Vlas",
      "country": "Bulgaria",
      "time": "Sveti Vlas - Bulgaria, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "sydney": {
      "city": "Sídney",
      "country": "Australia",
      "time": "Sídney - Australia, 14:00",
      "location": "Sydney Town Hall",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "tallinn": {
      "city": "Tallin",
      "country": "Estonia",
      "time": "Tallin - Estonia, 15:00 - Proyección y manifestación",
      "location": "Sõprus Cinema, Vana-Posti tn.8",
      "cleanTime": "15:00 - Proyección y manifestación",
      "day": "schedule13"
    },
    "tarragona": {
      "city": "Tarragona",
      "country": "España",
      "time": "Tarragona - España, 18:30",
      "location": "Balcó Mediterrani",
      "cleanTime": "18:30",
      "day": "schedule14"
    },
    "theHague": {
      "city": "La Haya",
      "country": "Países Bajos",
      "time": "La Haya - Países Bajos, 13:00 - 15:00",
      "location": "Delante del Palacio de la Paz / CPI",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "tbilisi": {
      "city": "Tiflis",
      "country": "Georgia",
      "time": "Tiflis - Georgia, 21:00",
      "location": "Tiflis",
      "cleanTime": "21:00",
      "day": "schedule14"
    },
    "tranas": {
      "city": "Tranås",
      "country": "Suecia",
      "time": "Tranås - Suecia, 11:00 - 13:00, 13:00",
      "location": "Storgatan 49 (Kultivera)",
      "cleanTime": "11:00 - 13:00, 13:00",
      "day": "schedule13"
    },
    "vienna": {
      "city": "Viena",
      "country": "Austria",
      "time": "Viena - Austria, 16:00 - 18:00",
      "location": "Stock im Eisen Platz (junto a Stephansdom)",
      "cleanTime": "16:00 - 18:00",
      "day": "schedule14"
    },
    "washingtonDC": {
      "city": "Washington D.C.",
      "country": "EE. UU.",
      "time": "Washington D.C. - EE. UU., 12:30 - 13:30",
      "location": "La Casa Blanca",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule14"
    },
    "wroclaw": {
      "city": "Wrocław",
      "country": "Polonia",
      "time": "Wrocław - Polonia, 13:00",
      "location": "Plaza de la Libertad (dirección People's Forum of Music)",
      "cleanTime": "13:00",
      "day": "schedule14"
    }
  },
  "help": {
    "organise": "¡Organiza! Para agregar tu ciudad, envía un correo electrónico a:",
    "email": "khersonhumansafari@gmail.com",
    "actionEmail": "antihumansafari@gmail.com",
    "share": "Compartir en {{platform}}",
    "website": "Sitio web",
    "facebook": "Facebook",
    "x": "X",
    "youtube": "YouTube",
    "bluesky": "Bluesky",
    "khs": {
      "name": "Kherson Human Safari",
      "desc": "Zarina Zabrisky, periodista y cineasta, lideró la manifestación mundial y dirigió el documental Kherson Human Safari."
    },
    "fellas": {
      "name": "Fellas4Europe",
      "desc": "Protección de civiles para las calles de Jersón — protegiendo a los civiles de los ataques de drones.",
      "foodDesc": "Ayuda alimentaria.",
      "foodNote": "Al donar, escribe «Food for Cherson» como concepto."
    },
    "ahs": {
      "name": "Proyecto Anti Human Safari",
      "desc": "Detectores de drones y chalecos protectores para voluntarios y servicios de emergencia en Jersón."
    },
    "pageTitle": "Para el Human Safari",
    "sectionIntro": "Desde el verano de 2024, los militares rusos utilizan pequeños drones para cazar, matar y aterrorizar a civiles en las calles de Jersón y otras ciudades de primera línea en Ucrania.",
    "sectionIntro2": "Es una campaña de asesinatos sistemática y deliberada: los operadores de drones rusos publican abiertamente las imágenes de sus víctimas en canales de Telegram para presumir. En mayo de 2025, la ONU reconoció el Human Safari como un crimen de guerra en curso.",
    "sectionIntro3": "Se está haciendo demasiado poco. El Human Safari debe detenerse.",
    "sectionIntroBold": "TÚ puedes ayudar. Así es cómo",
    "step2Title": "Organiza",
    "step3Title": "Cuéntaselo a la gente",
    "step3Para": "Usa los hashtags",
    "step3ParaPost": "y cuéntaselo a los demás",
    "instagram": "Instagram",
    "step2Bullet1": "una proyección de película",
    "step2Bullet2": "una acción pública",
    "step2Bullet3": "cobertura mediática",
    "publicActionLead": "Pon el foco sobre el safari humano allí donde estés.",
    "reachOutPre": "Puedes",
    "reachOut": "ponerte en contacto",
    "reachOutPost": "para pedir ideas y recursos",
    "newsCoverageLead": "a través de tus contactos en los medios. Háblales del safari humano y del riesgo para todas las zonas de conflicto actuales y futuras.",
    "putInTouchPre": "También puedes",
    "putInTouch": "ponernos en contacto directamente",
    "inform": "Infórmate",
    "informSub": "a ti mismo y a los demás",
    "policyTitle": "Política",
    "policyBody": "La propuesta Ley LORA (Ley de Responsabilidad de Operadores y Autoridades Responsables) establecería sanciones a lo largo de toda la cadena de responsabilidad: desde los operadores y comandantes rusos de drones FPV hasta el alto mando militar, así como los fabricantes y proveedores que hacen posible la producción y el despliegue de drones contra la población civil.",
    "policyHelp": "¿Puedes ayudar a nivel político?",
    "getInTouch": "Ponte en contacto",
    "disdict": {
      "title": "Disinformation Dictionary",
      "link": "Human Safari"
    },
    "donate": "Donar",
    "donateIntro": "Estas son iniciativas que ofrecen ayuda específica y de gran impacto para proteger directamente a los civiles de Jersón del Human Safari.",
    "shareTitle": "Difunde el mensaje",
    "filmScreening": "Organiza una proyección del documental Kherson Human Safari:",
    "howItStarted": "Cómo empezó",
    "kryla": {
      "name": "Kryla Foundation",
      "desc": "Apóyalos para pagar alojamiento y suministros básicos para los vecinos de Oleshky."
    }
  },
  "action": {
    "intro": "Empezamos con una manifestación mundial. Ahora puedes:",
    "helpLink": "ayuda aquí"
  },
  "accounts": {
    "heading": "Testimonios"
  },
  "media": {
    "close": "Cerrar",
    "view": "Ver el contenido",
    "previous": "Anterior",
    "next": "Siguiente",
    "andrushenkoCredit": "Oleksandr Andrushenko, fotocorresponsal del medio Vgoru",
    "khersonPoliceCredit": "de @khersonpolice",
    "antypenkoCredit": "Ivan Antypenko, fotoperiodista de Jersón",
    "telegramChannelCredit": "publicado en el canal de Telegram ruso del Human Safari «de Mariúpol a los Cárpatos»",
    "fruitSellerDescription": "Un vendedor de fruta perseguido por un dron de fibra óptica",
    "burntCarDescription": "Coche calcinado en Jersón",
    "bridgeAttackDescription": "Un adolescente asesinado por un dron FPV bajo un puente en Jersón",
    "busAttackDescription": "Uno de los muchos ataques con drones FPV contra el transporte público",
    "fpvDroneDescription": "Dron FPV de caza durante el «Human Safari»",
    "antiDroneNetsDescription": "Calle de Jersón cubierta con redes contra los drones del «Human Safari»",
    "firefighterDescription": "Un bombero apaga un coche tras un ataque del «Human Safari»; detrás yace una víctima"
  },
  "follow": {
    "title": "Sigue",
    "subHumanSafari": "fuentes de calidad que informan desde Jersón y sobre el Human Safari",
    "subDroneSiege": "fuentes de calidad que informan desde Jersón y sobre el asedio con drones",
    "localPress": "prensa local en ucraniano",
    "lang": {
      "english": "inglés",
      "german": "alemán",
      "ukrainian": "ucraniano"
    },
    "language": "Idioma: {{list}}",
    "languages": "Idiomas: {{list}}",
    "langSeparator": ", ",
    "zabrisky": {
      "name": "Zarina Zabrisky",
      "desc": "Periodista y cineasta estadounidense afincada en Jersón, colabora con Byline Times y Euromaidan Press; dirigió el documental Kherson Human Safari."
    },
    "naber": {
      "name": "Ibrahim Naber",
      "desc": "Reportero jefe del diario alemán Die Welt; informa periódicamente sobre el Human Safari en Jersón."
    },
    "kelley": {
      "name": "Brendan Kelley",
      "desc": "Escribe Kherson Weekly, una crónica continua de los ataques con drones rusos contra civiles en Jersón y las aldeas de alrededor."
    },
    "vgoru": {
      "name": "Vgoru",
      "desc": "Plataforma informativa independiente de la región de Jersón; cuenta la vida bajo los ataques y bajo la ocupación."
    },
    "suspilne": {
      "name": "Suspilne Jersón",
      "desc": "La redacción de Jersón de la radiotelevisión pública de Ucrania."
    },
    "most": {
      "name": "MOST",
      "desc": "Agencia de noticias local de Jersón, cubre la ciudad y la región."
    }
  },
  "rallies": {
    "oleshky2026": {
      "heroStop": "DETENGAN EL ASEDIO CON DRONES",
      "heroSave": "SALVEMOS OLESHKY",
      "worldwideRally": "Acción global",
      "heroDate": "Octubre",
      "infoText1": "Miles de civiles están atrapados bajo un asedio con drones en Oleshky, Hola Prystan, Stara Zburivka y Nova Zburivka. Las fuerzas rusas los utilizan como escudos humanos, escondiéndose tras ellos para lanzar ataques de safari humano con drones contra la orilla opuesta.",
      "infoText2": "La crisis es grave: faltan alimentos, agua, atención médica, medicinas, electricidad, gas y comunicaciones. Las carreteras están fuertemente minadas y los drones restringen cualquier movimiento. <bold>TÚ puedes ayudar. Únete a miles de personas en todo el mundo para exigir el fin del asedio con drones.</bold>",
      "imageAlt": "Un perro famélico entre huesos humanos en el Oleshky en ruinas, bajo un cielo rojo lleno de drones, con las palabras Stop Russian Drone Siege",
      "demandsTitle": "Pedimos:",
      "demand1": "corredores humanitarios seguros y eficaces hacia Oleshky y otras comunidades afectadas.",
      "demand2": "ayuda humanitaria inmediata y asistencia para las víctimas de los ataques de safari humano.",
      "demand3": "sanciones adecuadas contra las personas y las cadenas de suministro responsables de ataques contra civiles.",
      "demand4": "medidas para disuadir el uso de pequeños drones para atacar y aterrorizar sistemáticamente a civiles en Jersón, Ucrania y otros lugares.",
      "cities": {
        "edinburgh": {
          "city": "Edimburgo",
          "country": "Reino Unido",
          "time": "Edimburgo - Reino Unido, 14:00",
          "location": "Duke of Wellington Monument",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "birmingham": {
          "city": "Birmingham",
          "country": "Reino Unido",
          "time": "Birmingham - Reino Unido, 14:00 - 16:00",
          "location": "Frente al Hall of Memory, B1 2ND",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "vienna": {
          "city": "Viena",
          "country": "Austria",
          "time": "Viena - Austria, 15:00 - 17:00",
          "location": "Stephansplatz, 1010 Wien",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule27"
        },
        "munich": {
          "city": "Múnich",
          "country": "Alemania",
          "time": "Múnich - Alemania, 15:00 - 17:00",
          "location": "Marienplatz, 80331 München",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule3"
        },
        "london": {
          "city": "Londres",
          "country": "Reino Unido",
          "time": "Londres - Reino Unido, 16:00 - 18:00",
          "location": "Downing Street",
          "cleanTime": "16:00 - 18:00",
          "day": "schedule27"
        },
        "manchester": {
          "city": "Mánchester",
          "country": "Reino Unido",
          "time": "Mánchester - Reino Unido, 14:00 - 15:30",
          "location": "St Peter's Square",
          "cleanTime": "14:00 - 15:30",
          "day": "schedule26"
        },
        "sydney": {
          "city": "Sídney",
          "country": "Australia",
          "time": "Sídney - Australia, 14:00",
          "location": "Sydney Town Hall",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "paris": {
          "city": "París",
          "country": "Francia",
          "time": "París - Francia, 15:30 - 18:30",
          "location": "De la iglesia de San Volodímir a la Place Saint-Michel",
          "cleanTime": "15:30 - 18:30",
          "day": "schedule26"
        },
        "parisSep30": {
          "city": "París",
          "country": "Francia",
          "time": "París - Francia, 18:00",
          "location": "Metro Rambuteau",
          "cleanTime": "18:00",
          "day": "schedule30"
        },
        "lyon": {
          "city": "Lyon",
          "country": "Francia",
          "time": "Lyon - Francia, 14:00",
          "location": "Place de la Comédie",
          "cleanTime": "14:00",
          "day": "schedule27"
        },
        "dublin": {
          "city": "Dublín",
          "country": "Irlanda",
          "time": "Dublín - Irlanda, 13:00",
          "location": "The GPO (Oficina General de Correos)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "brussels": {
          "city": "Bruselas",
          "country": "Bélgica",
          "time": "Bruselas - Bélgica, 10:00 - 11:00",
          "location": "La Petite rue de la Loi, 1040 Bruselas (rotonda Schuman)",
          "cleanTime": "10:00 - 11:00",
          "day": "schedule28"
        },
        "ottawa": {
          "city": "Ottawa",
          "country": "Canadá",
          "time": "Ottawa - Canadá, 12:30 - 13:30",
          "location": "Embajada de Rusia, 285 Charlotte St",
          "cleanTime": "12:30 - 13:30",
          "day": "schedule2"
        },
        "nantes": {
          "city": "Nantes",
          "country": "Francia",
          "time": "Nantes - Francia, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule3"
        },
        "gdansk": {
          "city": "Gdansk",
          "country": "Polonia",
          "time": "Gdansk - Polonia, 18:30 - 19:30",
          "location": "Długi Targ, junto a la Fuente de Neptuno",
          "cleanTime": "18:30 - 19:30",
          "day": "schedule27"
        },
        "chicago": {
          "city": "Chicago",
          "country": "EE. UU.",
          "time": "Chicago - EE. UU., 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule27"
        },
        "chicagoOct4": {
          "city": "Chicago",
          "country": "EE. UU.",
          "time": "Chicago - EE. UU., 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "chicagoOct11": {
          "city": "Chicago",
          "country": "EE. UU.",
          "time": "Chicago - EE. UU., 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "chicagoOct18": {
          "city": "Chicago",
          "country": "EE. UU.",
          "time": "Chicago - EE. UU., 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule18"
        },
        "dresden": {
          "city": "Dresde",
          "country": "Alemania",
          "time": "Dresde - Alemania, 14:00",
          "location": "Neumarkt",
          "cleanTime": "14:00",
          "day": "schedule4"
        },
        "malaga": {
          "city": "Málaga",
          "country": "España",
          "time": "Málaga - España, 19:00",
          "location": "Plaza de la Marina",
          "cleanTime": "19:00",
          "day": "schedule3"
        },
        "londonSep29": {
          "city": "Londres",
          "country": "Reino Unido",
          "time": "Londres - Reino Unido, 18:00",
          "location": "Trafalgar Square",
          "cleanTime": "18:00",
          "day": "schedule29"
        },
        "plovdiv": {
          "city": "Plovdiv",
          "country": "Bulgaria",
          "time": "Plovdiv - Bulgaria, 17:00",
          "location": "Calle principal (Glavnata), junto a las escaleras Kamenitza / el letrero «Together»",
          "cleanTime": "17:00",
          "day": "schedule3"
        },
        "budapest": {
          "city": "Budapest",
          "country": "Hungría",
          "time": "Budapest - Hungría, 17:00 - 20:00",
          "location": "Szent István tér (plaza de San Esteban)",
          "cleanTime": "17:00 - 20:00",
          "day": "schedule30"
        },
        "londonOct1": {
          "city": "Londres",
          "country": "Reino Unido",
          "time": "Londres - Reino Unido, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule1"
        },
        "londonOct3": {
          "city": "Londres",
          "country": "Reino Unido",
          "time": "Londres - Reino Unido, 12:00",
          "location": "Trafalgar Square",
          "cleanTime": "12:00",
          "day": "schedule3"
        },
        "hamburg": {
          "city": "Hamburgo",
          "country": "Alemania",
          "time": "Hamburgo - Alemania, 14:00 - 16:00",
          "location": "Landungsbrücken, Jan-Fedder-Promenade, a la altura del Puente 1, 20359 Hamburgo",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "kiel": {
          "city": "Kiel",
          "country": "Alemania",
          "time": "Kiel - Alemania, 15:00 - 16:00",
          "location": "Holstenstraße",
          "cleanTime": "15:00 - 16:00",
          "day": "schedule4"
        },
        "oslo": {
          "city": "Oslo",
          "country": "Noruega",
          "time": "Oslo - Noruega",
          "location": "Eidsvolls plass",
          "cleanTime": "",
          "day": "schedule3"
        },
        "leipzig": {
          "city": "Leipzig",
          "country": "Alemania",
          "time": "Leipzig - Alemania, 17:00 - 18:00",
          "location": "Estación central (Willy-Brandt-Platz)",
          "cleanTime": "17:00 - 18:00",
          "day": "schedule5"
        },
        "londonOct9": {
          "city": "Londres",
          "country": "Reino Unido",
          "time": "Londres - Reino Unido, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule9"
        },
        "londonOct10": {
          "city": "Londres",
          "country": "Reino Unido",
          "time": "Londres - Reino Unido, 13:00",
          "location": "Trafalgar Square",
          "cleanTime": "13:00",
          "day": "schedule10"
        },
        "dublinOct11": {
          "city": "Dublín",
          "country": "Irlanda",
          "time": "Dublín - Irlanda, 13:00",
          "location": "The GPO (Oficina General de Correos)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "dublinOct25": {
          "city": "Dublín",
          "country": "Irlanda",
          "time": "Dublín - Irlanda, 14:00",
          "location": "The GPO (Oficina General de Correos)",
          "cleanTime": "14:00",
          "day": "schedule25"
        },
        "nantesOct31": {
          "city": "Nantes",
          "country": "Francia",
          "time": "Nantes - Francia, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule31"
        }
      },
      "posterStopSiege": "Detengan el asedio ruso con drones",
      "posterNoRoadOut": "Las vías de entrada y salida de Oleshky están bloqueadas",
      "posterHumanitarianCatastrophe": "Oleshky. Una catástrofe humanitaria bajo la ocupación",
      "seeGallery": "Ver / descargar carteles"
    },
    "artBy": "Arte: {{name}}",
    "downloadPoster": "Descargar cartel",
    "reel": {
      "download": "Descargar vídeo (MP4)"
    },
    "addDemo": {
      "title": "añade tu manifestación",
      "where": "dónde: ciudad/pueblo",
      "contact": "correo/número",
      "message": "mensaje: a quién representas, tu manifestación está confirmada o en preparación, enlace al anuncio en línea, otros detalles",
      "submit": "Enviar",
      "sending": "Enviando…",
      "thanks": "¡Gracias! Nos pondremos en contacto.",
      "error": "Algo salió mal. Inténtalo de nuevo.",
      "contactInvalid": "Introduce un correo válido o un número de teléfono con prefijo internacional (p. ej. +34 612 345 678).",
      "date": "fecha",
      "time": "hora de inicio (local)",
      "whereInvalid": "Introduce el nombre de una ciudad o pueblo, p. ej. Madrid o Kyiv, Ucrania.",
      "datePlaceholder": "fecha: dd/mm"
    }
  },
  "seo": {
    "oleshky": {
      "title": "Detengan el asedio con drones — Salvemos Oleshky",
      "description": "Drones rusos asedian a miles de civiles en Oleshky, Ucrania ocupada, sin comida, agua ni medicinas. Encuentra una manifestación cerca de ti y exige un paso seguro."
    },
    "leftBank": {
      "title": "Asedio con drones de Oleshky y la región ocupada de Jersón",
      "description": "Miles de civiles están atrapados bajo un asedio ruso con drones en Oleshky, Hola Prystan y pueblos cercanos ocupados. Descubre qué ocurre y cómo puedes ayudar."
    },
    "help": {
      "title": "Detengan el Human Safari — Drones rusos cazan civiles en Jersón",
      "description": "Drones rusos cazan civiles en Jersón, Ucrania. Infórmate sobre el crimen de guerra Human Safari y cómo puedes ayudar a detenerlo."
    },
    "action": {
      "title": "Concentración mundial de diciembre de 2025 — Detengan el Human Safari",
      "description": "Fotos, carteles y lugares de la concentración mundial de diciembre de 2025 contra los ataques rusos con drones a civiles en Jersón, Ucrania."
    },
    "rallies": {
      "title": "Fotos de las concentraciones — Detengan el Human Safari",
      "description": "Fotos de concentraciones en todo el mundo contra los ataques rusos con drones a civiles en Jersón, Ucrania."
    },
    "resources": {
      "title": "Recursos sobre el Human Safari — Informes, artículos y testimonios",
      "description": "Informes, artículos, entrevistas y testimonios sobre los ataques rusos con drones a civiles en Jersón, Ucrania."
    },
    "reel": {
      "title": "Salvemos Oleshky — Vídeo de las manifestaciones",
      "description": "Vídeo de las manifestaciones mundiales «Salvemos Oleshky», octubre de 2026."
    }
  }
}
